import { useMemo } from 'react';

import { getGeneralCommentThreads } from '@confluence/comments-panel-utils';
import { useCommentsDataState } from '@confluence/comments-data';

export const useFooterComments = () => {
	const { orderedActiveAnnotationIdList, commentsDataMap, removedThreadsMap } =
		useCommentsDataState();

	return useMemo(() => {
		const footerCommentThreads = getGeneralCommentThreads({
			commentsDataMap,
			orderedActiveAnnotationIdList,
			removedThreadsMap,
		});

		const footerCommentIds = footerCommentThreads.map((thread) => thread.id);

		return {
			footerCommentIds,
			footerCommentThreads,
		};
	}, [commentsDataMap, orderedActiveAnnotationIdList, removedThreadsMap]);
};
